module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/kam-region/kam-region.component.sass
// module id = ./src/app/modules/user/components/kam-region/kam-region.component.sass
// module chunks = main